export interface OutSample {
  dropped: boolean;
  dynamic: boolean;
  supportConnected: boolean;
  boundsMaxY: number;
  outLineY: number;
  hasEnteredEscapeCorridor?: boolean;
  hasEverContactedStack?: boolean;
}

export interface BoundsSnapshot {
  minX: number;
  maxX: number;
  minY: number;
  maxY?: number;
}

export interface SupportBounds {
  minX: number;
  maxX: number;
  minY?: number;
  maxY: number;
}

export interface OutMetadata {
  hasEnteredEscapeCorridor: boolean;
}

export function isOut(sample: OutSample): boolean {
  return sample.dropped
    && sample.dynamic
    && !sample.supportConnected
    && sample.boundsMaxY < sample.outLineY;
}

export function updateEscapeMetadata(
  body: BoundsSnapshot,
  support: SupportBounds,
  metadata: OutMetadata,
): OutMetadata {
  const besideSupport = body.maxX < support.minX || body.minX > support.maxX;
  const atSupportHeight = body.minY <= support.maxY;
  return {
    hasEnteredEscapeCorridor: metadata.hasEnteredEscapeCorridor || (besideSupport && atSupportHeight),
  };
}

export function detectSupportPenetration(
  previousBody: BoundsSnapshot,
  currentBody: BoundsSnapshot,
  support: Required<SupportBounds>,
  hasActiveSupportContact: boolean,
): boolean {
  const startedEntirelyBelow = previousBody.minY >= support.maxY;
  const endedEntirelyAbove = currentBody.maxY !== undefined && currentBody.maxY <= support.minY;
  const sweptMinX = Math.min(previousBody.minX, currentBody.minX);
  const sweptMaxX = Math.max(previousBody.maxX, currentBody.maxX);
  const sweptAcrossSupportX = sweptMaxX > support.minX && sweptMinX < support.maxX;
  return startedEntirelyBelow && endedEntirelyAbove && sweptAcrossSupportX && !hasActiveSupportContact;
}
